import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './guards/auth.guard'
import { permissionGuard } from './guards/permission.guard'
import './types' // Import route meta types

// Import route modules
import { authRoutes } from './modules/auth.routes'
import { dashboardRoutes } from './modules/dashboard.routes'
import { projectRoutes } from './modules/projects.routes'
import { userRoutes } from './modules/users.routes'
import { categoryRoutes } from './modules/categories.routes'
import { productRoutes } from './modules/products.routes'
import { aurumRoutes } from './modules/aurum.routes'
import { customerRoutes } from './modules/customers.routes'
import { orderRoutes } from './modules/orders.routes'

import { eventReservationRoutes } from './modules/event-reservations.routes'
import { assetRoutes } from './modules/assets.routes'
import { subscriptionRoutes } from './modules/subscriptions.routes'
import { invoicingRoutes } from './modules/invoicing.routes'
import { orchestrationRoutes } from './modules/orchestration.routes'
import { pageRoutes } from './modules/pages.routes'
import { menuRoutes } from './modules/menus.routes'
import { contactGroupRoutes } from './modules/contact-groups.routes'
import { contactRoutes } from './modules/contacts.routes'
import { videoRoutes } from './modules/videos.routes'
import { emailTemplateRoutes } from './modules/email-templates.routes'
import { formRoutes } from './modules/forms.routes'
import { ticketRoutes } from './modules/tickets.routes'
import { auditLogRoutes } from './modules/audit-log.routes'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...authRoutes,
    ...dashboardRoutes,
    ...projectRoutes,
    ...userRoutes,
    ...categoryRoutes,
    ...productRoutes,
    ...aurumRoutes,
    ...customerRoutes,
    ...orderRoutes,

    ...eventReservationRoutes,
    ...assetRoutes,
    ...subscriptionRoutes,
    ...invoicingRoutes,
    ...orchestrationRoutes,
    ...pageRoutes,
    ...menuRoutes,
    ...contactGroupRoutes,
    ...contactRoutes,
    ...videoRoutes,
    ...emailTemplateRoutes,
    ...formRoutes,
    ...ticketRoutes,
    ...auditLogRoutes,
  ],
})

// Apply guards in order: authentication first, then permissions
router.beforeEach(authGuard)
router.beforeEach(permissionGuard)

export default router
